module.exports = __webpack_public_path__ + "static/img/animales_08.32edb33f.jpg";